import Home from "./Home/Home";
import Footer from "./Footer/Footer";
import ContactForm from "./Contacts/Contacts";

const App = () => (
  <>
    <Home />
    <ContactForm />
    <Footer />
  </>
);

export default App;
